import React, {useEffect} from 'react'
import WhyUsIcon from '../../images/whyUs.webp'
import { Link } from 'gatsby'
import AOS from 'aos';
import 'aos/dist/aos.css';

function WhyUs() {

    useEffect(() => {
        // Inicializa AOS solo cuando el componente se monta en el cliente
        AOS.init({
          duration: 500,
          easing: 'ease-in-out',
        });
      }, []);

  return (
    <div className="Content__whyUs">
        <div className="container">
            <div className="Content__whyUs--container">
                <div className="Content__whyUs--left" data-aos="fade-down" data-aos-delay="300">
                    <div className="Content__whyUs--title">
                        <h2>¿Por qué <span>elegirnos?</span></h2>
                    </div>
                    <div className="Content__whyUs--subtitle">
                        <span>¡Atrévete al cambio!</span>
                    </div>
                    <div className="Content__whyUs--listContainer">
                        <div className="Content__whyUs--listContainer-item">
                            <div className="whyUs__listContainer--item-title">
                                <h4>Efectividad de Servicio</h4>
                            </div>
                            <div className="whyUs__listContainer--item-text">
                                <p>Nos distinguimos por nuestra alta eficiencia en entregas, logrando una efectividad superior al 97%</p>
                            </div>
                        </div>
                        <div className="Content__whyUs--listContainer-item">
                            <div className="whyUs__listContainer--item-title">
                                <h4>Servicios Sameday y Nextday</h4>
                            </div>
                            <div className="whyUs__listContainer--item-text">
                                <p>Ofrecemos opciones de entrega al mismo día o al día siguiente, adaptándonos a la urgencia de cada cliente.</p>
                            </div>
                        </div>
                        <div className="Content__whyUs--listContainer-item">
                            <div className="whyUs__listContainer--item-title">
                                <h4>Tecnología De Punta</h4>
                            </div>
                            <div className="whyUs__listContainer--item-text">
                                <p>Nuestro Dashboard ofrece integraciones esenciales, transparencia en el seguimiento de envíos y asegura una experiencia de usuario excepcional, tanto para nuestros clientes directos como para los finales.</p>
                            </div>
                        </div>
                        <div className="Content__whyUs--listContainer-item">
                            <div className="whyUs__listContainer--item-title">
                                <h4>Acompañamiento Personalizado</h4>
                            </div>
                            <div className="whyUs__listContainer--item-text">
                                <p>Brindamos atención al cliente personalizada, los 7 días de la semana, garantizando una respuesta inmediata y efectiva.</p>
                            </div>
                        </div>
                    </div>
                    <div className="Content__whyUs--button">
                        <Link to={'/servicios'}>
                            <button>Conócenos</button>
                        </Link>
                    </div>
                </div>
                <div className="Content__whyUs--banner">
                    <img src={WhyUsIcon} alt="por-que-nosotros-icon" width="477" height="590" />
                </div>
            </div>
        </div>
    </div>
  )
}

export { WhyUs }